import {OnlineUsersState} from "../types/OnlineUsersState";

export const state: OnlineUsersState = {
    counters: {},
    updateIntervalId: null,
    activities: {},
    watches: {},
    needCounters: true
}